export default `
<section class="bg-white first container">
 <div class="href center"><a href="++{{section13link}}">++{{section13linktext}}</a></div>
</section>
`